import {createContext, FC, useContext} from 'react';
import {trimChar, WithChildren} from '../helpers';

export interface Config {
	publicUrl: string;
	apiUrl: string;
	makeApiUrl: (path: string) => string;
	mapKey: string;
}

const config: Config = {
	publicUrl: process.env.PUBLIC_URL ?? 'https://enterprise.knower.jp/',
	apiUrl: process.env.REACT_APP_API_BASE_URL ?? '',
	makeApiUrl: (path: string) => {
		return `${trimChar(process.env.REACT_APP_API_BASE_URL ?? '', '/')}/${trimChar(path, '/')}`;
	},
	mapKey: process.env.REACT_APP_GOOGLE_MAP_KEY ?? '',
};

const ConfigContext = createContext<Config>(config);

export const useConfig = () => {
	return useContext(ConfigContext);
};

const ConfigProvider: FC<WithChildren> = ({children}) => {
	return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

export const useApiUrl = (path: string) => {
	const {makeApiUrl} = useConfig();
	return makeApiUrl(path);
};

export default ConfigProvider;
